import React, { useState } from 'react';
import './stylesheets/contact.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BACKEND } from './config';
import Loading from 'react-loading';
import AlertModal from './pages/components/AlertModal';

export default function ContactUs() {
  const [complaintData, setComplaintData] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false); // State to control the modal visibility
  const [modalText, setModalText] = useState(''); // State to control the modal text

  const nav = useNavigate();
  const maxCharacters = 250;

  const handleDataChange = (field) => (event) => {
    const inputText = event.target.value;
    if (field !== 'complaint' || inputText.length <= maxCharacters) {
      setComplaintData((prev) => {
        const updated = { ...prev };
        updated[field] = inputText;
        return updated;
      });
    }
  };

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${BACKEND}/complaints`, complaintData)
      .then(() => {
        setLoading(false);
        setModalText("Complaint Submitted");
        setModalVisible(true); // Show the modal instead of alert
      })
      .catch((error) => {
        setLoading(false);
        setModalText(error.message);
        setModalVisible(true); // Show the modal instead of alert
      });
  }

  const closeModal = () => {
    setModalVisible(false);
    nav('/'); // Navigate after closing the modal
  };

  return (
    <div className="ContactView">
      <form id='ContactForm' onSubmit={handleSubmit} style={{ }}>
        <div className="ContactBox">
          <h1 className="ContactTitle">Get in Touch with Us</h1>
          <h1 className="ContactTitle" id='ContactText'>Fill out the form below, and our team will respond to you as soon as possible.</h1>
          <div className="ContactRow">
            <input
              required
              id="fullName"
              type="text"
              placeholder="Name"
              onChange={handleDataChange('fullName')}
              value={complaintData.fullName}
            />
          </div>
          <div className="ContactRow">
            <input
              required
              id="email"
              type="text"
              placeholder="Email or Phone Number"
              onChange={handleDataChange('email')}
              value={complaintData.email}
            />
          </div>
          <div className="ContactRow">
            <h7>{maxCharacters - (complaintData.complaint?.length || 0)} characters left</h7>
            <textarea
              style={{resize:'none'}}
              required
              id="complaint"
              value={complaintData.complaint}
              onChange={handleDataChange('complaint')}
              placeholder="We’re here to help! If you have any questions, feedback, or need assistance, please don’t hesitate to reach out"
              rows={4}
              maxLength={maxCharacters}
            />
          </div>
          <button disabled={loading}>
            {loading ? <Loading type="spinningBubbles" height={20} width={20} /> : 'Submit'}
          </button>
        </div>
      </form>

      <div id='MoreContact' style={{ marginTop: '1%', textAlign:'center' }}>
        <h4 style={{ fontSize: '2svh', color: '#34AED4', fontWeight:800}}>
          Prefer to Speak with Us?
        <h4 style={{ fontSize: '2svh', color: 'black' }}>
          Feel free to call us at [Your Phone Number]. Our representatives are available [insert hours of availability] to assist you.
        </h4>
        <h4 style={{ fontSize: '2svh', color: 'black' }}>
          Thank you for your interest in Foras. We look forward to connecting with you!
        </h4>
        </h4>


        {/* <h4 style={{ fontSize: '2svh', color: 'black' }}>
          You can email us at foras.freelance@gmail.com or refer to our{' '}
          <Link id="QuickLinks" style={{ textDecoration: 'none' }} to="/PrivacyPolicy">
            Privacy Policy
          </Link>{' '}
          or{' '}
          <Link id="QuickLinks" style={{ textDecoration: 'none' }} to="/TermsCondition">
            Terms and Conditions
          </Link>{' '}
          for more information
        </h4> */}
      </div>

      {/* Alert Modal */}
      <AlertModal
        show={modalVisible}
        text={modalText}
        widthController={50}
        buttonsVisible={true}
        b2={{ text: 'OK', onClick: closeModal }}
        b2bg={"#34AED4"}
      />
    </div>
  );
}
